import Vue from 'vue'
import Vuex from 'vuex'
import {firebase, firestore} from '../firebase'
import router from '../router'
import moment from 'moment'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        darkMode: true,
        post: [],
        loginAs: {
            user_id: '',
            data: ''
        },
    },
    getters: {},
    mutations: {
        toggleTheme (state) {
            state.darkMode = !state.darkMode;
            // localStorage.setItem('darkMode', state.darkMode);
        },
        loginAs (state) {
            if (localStorage.getItem('uid') != null) {
                firestore.collection('users').doc(localStorage.getItem('uid')).get().then(result=>{
                    state.loginAs.user_id = result.id
                    state.loginAs.data    = result.data()
                });
            }
        },
        logout (state) {
            firebase.auth().signOut()
            .then((result)=>{
                state.loginAs.user_id = '';
                state.loginAs.data    = '';
                localStorage.removeItem('login');
                localStorage.removeItem('uid');
                router.push('/login');
            })
        },
        getData (state) {

        },
        createPost (state, postData) {
            firestore.collection('post').add({
                content: postData,
                love: [],
                createdBy: {
                    user_id: firebase.auth().currentUser.uid,
                    username: state.loginAs.data.username
                },
                createdAt: moment().format('MMMM Do YYYY, h:mm:ss a'),
            }).then(result=>{
                
            })
        },
        deletePost (state, id) {
            let data = firestore.collection('post').doc(id);
            data.get().then(result=>{
                if (result.data().createdBy.user_id == state.loginAs.user_id) {
                    data.delete();
                }
            });
        },
        loveColor (state, status) {
            if (status == 'clicked') {
                return 'red';
            }else {
                return 'white';
            }
        },
        lovePost (state, id) {
            let data = firestore.collection('post').doc(id);
            let user = {
                user_id: state.loginAs.user_id,
                username: state.loginAs.data.username
            }
            
            firestore.collection('post')
            .where(firebase.firestore.FieldPath.documentId(), '==', id)
            .where('love','array-contains', user)
            .get().then(result=>{
                if (result.docs.length === 0) {
                    data.update({
                        love: firebase.firestore.FieldValue.arrayUnion(user)
                    })
                }else {
                    data.update({
                        love: firebase.firestore.FieldValue.arrayRemove(user)
                    })
                }
            });
        }
    },
    actions: {

    }
})


// WEBPACK FOOTER //
// ./src/store/index.js